export default __webpack_public_path__ + "static/0035-fc7dcf63e983ad9e07761346b35e803d.png";